
import React, { Component } from 'react';
import { Modal, Transfer } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

class MemberTeam extends Component {

    state = {
        dataSource: [],
        targetKeys: [],
    }

    initData = (memberCode, callback) => {
        //读取已设置的人员和可以设置的人员
        http.get({
            url: "/" + this.props.content + '/findMemberAndUser',
            data: { memberCode: memberCode },
            success: (res) => {
                let all = [];
                let has = [];
                if (res.all != null && res.all.length > 0) {
                    for (let i = 0; i < res.all.length; i++) {
                        all.push({
                            key: res.all[i].username,
                            title: res.all[i].name,
                            description: res.all[i].username,
                        });
                    }
                    if (res.has != null && res.has.length > 0) {
                        for (let i = 0; i < res.has.length; i++) {
                            has.push(res.has[i].username);
                        }
                    }
                }
                this.setState({
                    dataSource: all,
                    targetKeys: has
                });
                if(callback){
                    callback(res);
                }
            }
        });
    }

    save = () => {
        let values = {};
        let memberCode = this.props.editData.code
        if (memberCode !== undefined && memberCode != null) {
            values["memberCode"] = memberCode;
        }
        values["usernames"] = this.state.targetKeys.join(",");
        http.post({
            url: "/" + this.props.content + '/updateMemberTeam',
            data: values,
            success: (res) => {
                this.props.successCallback(this.props.queryData);
                this.props.onCancel();
                messager.notify("保存成功！");
            }
        });
    };

    handleChange = (targetKeys, direction, moveKeys) => {
        this.setState({ targetKeys: targetKeys });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={540}
                visible={visible}
                title="商户人员配置"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ targetKeys: [] }) }}
            >
                <Transfer
                    dataSource={this.state.dataSource}
                    showSearch
                    locale={{ itemUnit: '人', itemsUnit: '人', searchPlaceholder: '用户名' }}
                    listStyle={{
                        width: 200,
                        height: 300,
                    }}
                    operations={['添加', '移除']}
                    targetKeys={this.state.targetKeys}
                    onChange={this.handleChange}
                    render={item => `${item.title}`}
                />

            </Modal>
        );
    }
}

export default MemberTeam;